const ckLocale = document.querySelector('[ck_locale]');
let ckContinueWithText;
if(ckLocale){
  ckContinueWithText = ckLocale.getAttribute('ck_locale');
}

var pdpShippingInfo = (() => {
  var open = (container) => {
    container.classList.add('open');
    if (container.querySelector('.product-form__shipping-info--description').getBoundingClientRect().top <= 0) {
      container.classList.add('bottom-position');
    }
  }
  var close = (container) => {
    container.classList.remove('open');
    setTimeout(() => {
      container.classList.remove('bottom-position');
    }, 500);
  }
  var initialize = () => {
    document.querySelectorAll('[js-shipping-info-trigger]').forEach(element => {
      const container = element.closest('[js-shipping-info-container]');
      element.addEventListener('mouseover', () => {
        open(container);
      });
      element.addEventListener('click', () => {
        open(container);
      });
      element.addEventListener('focusout', () => {
        close(container);
      });
      element.addEventListener('mouseleave', () => {
        close(container);
      });
    });
  }
  return {
    init: initialize
  }
})();

var tresholdSystem = (() => {
  var initialize = () => {

  }
  return {
    init: initialize
  }
})();

var collectionHero = (() => {
  let anchorButton = null;
  let targetSection = null;
  var reinitAnchorButton = () => {
    anchorButton = document.querySelector('[js-collection-hero-anchor]');
    if (!anchorButton) return;
    targetSection = document.querySelector(anchorButton.getAttribute('data-href'));
    if (!targetSection) return;
    if (targetSection.getBoundingClientRect().top < window.innerHeight - 50 && window.scrollY > 50) {
      anchorButton.classList.add('inactive');
    } else {
      anchorButton.classList.remove('inactive');
    }
  }
  return {
    reinitAnchorButton: reinitAnchorButton
  }
})();

var bdModal = (() => {
  var open = (modal) => {
    if (!modal) return;
    modal.classList.add('open');
  }
  var close = (modal) => {
    if (!modal) return;
    modal.classList.remove('open');
  }
  var initialize = () => {
    document.querySelectorAll('[js-bd-modal]').forEach(modal => {
      modal.querySelectorAll('[js-close]').forEach(closeButton => {
        closeButton.addEventListener('click', () => {
          close(closeButton.closest('[js-bd-modal]'));
        });
      });
    });
    document.querySelectorAll('[js-bd-modal-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => {
        if (trigger.closest('[js-container]')) {
          open(trigger.closest('[js-container]').querySelector('[js-bd-modal]'));
        }
      });
    });
  }
  return {
    init: initialize
  }
})();

var aboutStudiesShowMore = (() => {
  var open = (container) => {
    if (!container) return;
    container.classList.add('open');
    const moreBlocks = container.querySelector('.blocks>.more-blocks');
    if (!moreBlocks) return;
    moreBlocks.style.maxHeight = moreBlocks.scrollHeight + 'px';
  }
  var close = (container) => {
    if (!container) return;
    container.classList.remove('open');
    const moreBlocks = container.querySelector('.blocks>.more-blocks');
    if (!moreBlocks) return;
    moreBlocks.style.maxHeight = '0px';
  }
  var initialize = () => {
    document.querySelectorAll('.section--about-studies--container .trigger-button').forEach(element => {
      element.addEventListener('click', () => {
        const container = element.closest('.section--about-studies--container');
        if (container.classList.contains('open')) {
          close(container);
        } else {
          open(container);
        }
      });
    });
  }
  return {
    init: initialize
  }
})();

var prioShippingApp = (() => {
  var openModal = (modal) => {
    if (!modal) return;
    modal.classList.add('open');
  }

  var closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('open');
  }

  var addToCart = (variantId, container) => {
    if (!variantId || variantId == '' || !container) return;
    const checkbox = container.querySelector('[js-add-prio-shipping]');
    container.classList.add('disabled');
    const formData = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {'_prio_shipping': 'true'}
      }]
    };
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      window.cart.get().then(window.renderCart);
      container.classList.remove('disabled');
      if (checkbox) checkbox.classList.add('checked');
    })
    .catch(error => {
      container.classList.remove('disabled');
      console.error('Error adding product to cart:', error);
    });
  }

  function removeFromCart(variantId, container) {
    if (!variantId || variantId == '' || !container) return;
    const checkbox = container.querySelector('[js-add-prio-shipping]');
    container.classList.add('disabled');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      window.cart.get().then(window.renderCart);
      container.classList.remove('disabled');
      if (checkbox) checkbox.classList.remove('checked');
    })
    .catch(error => {
      container.classList.remove('disabled');
      console.error('Error removing from cart:', error);
    });
  }

  var addPrioShipping = (container) => {
    if (!container || container.classList.contains('disabled')) return;
    addToCart(container.getAttribute('data-prio-product-variant-id'), container);
  }

  var removePrioShipping = (container) => {
    if (!container || container.classList.contains('disabled')) return;
    removeFromCart(container.getAttribute('data-prio-product-variant-id'), container);
  }

  var initializeCheckBox = (checkbox) => {
    if (!checkbox) return;
    window.cart.get().then(cart => {
      const items = cart.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].properties?._prio_shipping) {
          checkbox.classList.add('checked');
          return;
        }
      }
    });

  }
  
  var initialize = () => {
    document.querySelectorAll('[js-prio-shipping-details-modal-trigger]').forEach(element => {
      element.addEventListener('click', () => {
        const container = element.closest('[js-container]');
        if (container) openModal(container.querySelector('[js-prio-shipping-details-modal]'));
      });
    });
    document.querySelectorAll('[js-prio-shipping-details-modal] [js-close]').forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        closeModal(closeButton.closest('[js-prio-shipping-details-modal]'));
      });
    });
    document.querySelectorAll('[js-add-prio-shipping]').forEach(element => {
      initializeCheckBox(element);
      element.addEventListener('click', () => {
        if (element.classList.contains('checked')) {
          removePrioShipping(element.closest('[js-container]'));
        } else {
          addPrioShipping(element.closest('[js-container]'));
        }
      });
    });
    document.addEventListener("quick-cart:close", function () {
      document.querySelectorAll('[js-prio-shipping-details-modal]').forEach(modal => {
        closeModal(modal);
      });
    });
  }

  return {
    init: initialize,
    remove: removePrioShipping
  }
})();

var app = (() => {
  var initialize = () => {
    // For Shipping info on PDP
    pdpShippingInfo.init();

    // For treshold system on quick cart
    tresholdSystem.init();

    // For custom modal
    bdModal.init();

    aboutStudiesShowMore.init();

    // For prio+ shipping details modal
    prioShippingApp.init();

    // For PDP upsell modal
    PDPUpsellModalApp.init();
  }
  return {
    init: initialize
  }
})();
document.addEventListener('DOMContentLoaded', () => {
  app.init();
});

document.addEventListener('scroll', () => {
  collectionHero.reinitAnchorButton();
});

const moneyFormat = "${{amount}}";
function formatMoney$1(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
var formatMoney = (val) => formatMoney$1(val, window.theme.moneyFormat || "${{amount}}");

//Variables
const variantPopupBtn = document.querySelector(".js-variant-popup-btn[type='button']");
let closeButtons = document.querySelectorAll(".variant-close-btn");
let bgOverlay = document.querySelector(".variant-bg-overlay");
let stepOneBtn = document.querySelector(".js-variant-qty-btn .js-variant-qty-meta");
let stepTwoBtn = document.querySelector(".js-variant-qty-btn .js-variant-duplicate-btn");
let tabs = document.querySelector(".variant-change-tab");
let customModelMain = document.querySelector(".variant-custom-model-main");
let variantSelector = document.querySelectorAll(".variant-popup-img-option .variant-inner-box");
let variantBackBtn = document.querySelector(".js-back-btn");
let mainSelect = document.querySelector("[data-product-variants] select");
let variantMetaQtyBtn = document.querySelector(".js-variant-qty-meta span");
let paymentIcons = document.querySelector(".custom-payment-icons_variant");
let checkboxRecahrge = document.querySelector(".js-recharge-checkbox");
let sellingPlanCustomSelect = document.querySelector("#sellingPlanCustom");
const scrollButton = document.querySelector(".js-scrolls");
const shippingPlusSummary = document.querySelectorAll('[js-shipping-plus-summary]');

if (scrollButton) {
  scrollButton.addEventListener("click", function () {
    const shopReviewSlider = document.querySelector("shop-review-slider");
    if (shopReviewSlider) {      
      window.scroll({
        top: shopReviewSlider.offsetTop,
        behavior: "smooth",
      });
    }
  });
}

function setShippingInfoSummary(flag) {
  if (!shippingPlusSummary || shippingPlusSummary.length === 0) return;
  shippingPlusSummary.forEach(element => {
    if (flag) element.style.display = 'none';
    else element.style.display = 'block';
  });
}

function checkBtnForVariantsAndSetSubmit() {
  const onlyDefaultVariantBtn = document.querySelector(".product-form__cart-submit");

  // Return early if the button doesn't exist
  if (!onlyDefaultVariantBtn) {
    return;
  }
// here is start trash code
  return;
// here is end trash code
  // Check for 'product-only-default' class and absence of 'product-with-subscription'
  if (onlyDefaultVariantBtn.classList.contains("product-only-default") && !onlyDefaultVariantBtn.classList.contains("product-with-subscription")) {
    console.log("only default and no subscription");
    setShippingInfoSummary(true);
    return variantPopupBtn?.setAttribute("type", "submit");
  }

  // Check for both 'product-only-default' and 'product-with-subscription'
  else if (onlyDefaultVariantBtn.classList.contains("product-only-default") && onlyDefaultVariantBtn.classList.contains("product-with-subscription")) {
    console.log("default product with subscription");
    setShippingInfoSummary(true);
    disableVariantView();
  }

  // Check for absence of both 'product-only-default' and 'product-with-subscription'
  else if (!onlyDefaultVariantBtn.classList.contains("product-only-default") && !onlyDefaultVariantBtn.classList.contains("product-with-subscription")) {
    console.log("variants present but no subscription");
    setShippingInfoSummary(false);
    disableWidgetView();
  }
}

function disableVariantView() {
  paymentIcons.classList.remove("hide");
  tabs.classList.add("variant-tabing");
  document.querySelector(".popup-title_2").classList.remove("hide");
  document.querySelector(".popup-title_1").classList.add("hide");
  if (shippingPlusSummary && shippingPlusSummary.length > 0) {
    shippingPlusSummary.forEach(element => {
      element.classList.add("hide");
    });
  }
  variantMetaQtyBtn.classList.add("hidden");
  stepOneBtn?.classList.add("hidden");
  stepTwoBtn?.classList.remove("hidden");
  checkboxRecahrge.checked = false;
}

function disableWidgetView() {
  stepOneBtn?.classList.add("hidden");
  stepTwoBtn?.classList.remove("hidden");
  stepTwoBtn?.classList.add("no-widget-screen-allow");
  paymentIcons?.classList.remove("hide");
}

//Recharge Widget Load
window.rechargeWidget = function rechargeWidget(param) {
  let attempts = 0;
  let maxAttempts = 2; 
  let setIntervalRecharge = setInterval(findRecahrgeWidget, 1000);
  function findRecahrgeWidget() {
  
    if (document.querySelector(".rc-widget")) {
      clearInterval(setIntervalRecharge);

      if(typeof(hbFirstVariant) == 'undefined') { 
        if(document.querySelector(".js-discount-price")){
          document.querySelector(".js-discount-price").innerHTML = '';
        }
      }
    
      //Discount and main price diffrence
      let oneTimePrice = document.querySelector(".onetime-radio .price-label").innerHTML;
      let RechargePrice = document.querySelector(".subscription-radio .price-label").innerHTML;
      let diffrence = (parseInt(oneTimePrice) - parseInt(RechargePrice));

      if(typeof(hbFirstVariant) == 'undefined') {    
        if(document.querySelector(".js-discount-price")) document.querySelector(".js-discount-price").innerHTML = formatMoney(diffrence*100);
      }

      //Subscription FETCH
      if (param == true) {
       
        if(sellingPlanCustomSelect) sellingPlanCustomSelect.classList.remove('hidden');
        if(stepTwoBtn){
          stepTwoBtn.querySelector(".recharge-price").classList.remove("hidden");
          stepTwoBtn.querySelector(".onetime-price").classList.remove("hidden");
          stepTwoBtn.querySelector(".recharge-price").innerHTML = document.querySelector(".onetime-radio .price-label").innerHTML.replace('.00', '').replace(',00', '') ;
          stepTwoBtn.querySelector(".onetime-price").innerHTML = document.querySelector(".subscription-radio .price-label").innerHTML.replace('.00', '').replace(',00', '');                
        }
        document.querySelectorAll(".subscription-radio").forEach((subsave) => {
            subsave.click();
        });        
        sellingPlanCustomSelect.addEventListener("change", function () {
          let selectedPlanID = sellingPlanCustomSelect.value;
          document.querySelector('.rc-selling-plans-dropdown__select').value = selectedPlanID;
          document.querySelector(".rc-selling-plans-dropdown__select").dispatchEvent(new Event('change'));           
        });
      }

      //ONE TIME FETCH
      if (param == false) {
        if(sellingPlanCustomSelect) sellingPlanCustomSelect.classList.add('hidden');
        if(stepTwoBtn){
          stepTwoBtn.querySelector(".onetime-price").classList.remove("hidden");
          stepTwoBtn.querySelector(".recharge-price").classList.add("hidden");
          stepTwoBtn.querySelector(".onetime-price").innerHTML = document.querySelector(".onetime-radio .price-label").innerHTML.replace('.00', '').replace(',00', '');        
        }
        document.querySelectorAll(".rc-radio.onetime-radio").forEach((oneTime) => {
          oneTime.click();
        });        
      }
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(setIntervalRecharge);
        checkBtnForVariantsAndSetSubmit();
        console.log("Widget not found after " + maxAttempts + " attempts, stopping the check.");
      } else {
        console.log("Attempt " + attempts + ": Widget not found, checking again...");
      }
    }
  }
};

window.rechargeWidget(false); 

//Modal
function initModal() {
  if (variantPopupBtn) {
    const modalTrigger = document.querySelector(".js-variant-popup-btn");
    modalTrigger.addEventListener("click", function (ele) {
      if (modalTrigger.type === "submit") {
        return
      }
      if (variantSelector[variantSelector.length - 1]) {
        variantSelector[variantSelector.length - 1].click();
      }
      window.rechargeWidget(false);
      let dataProductId = parseInt(
        ele.currentTarget.getAttribute("data-product-id")
      );
      customModelMain.classList.add("variant-model-open");
      if (window.innerWidth >= 959) {
        customModelMain.querySelector('.variant-custom-model-inner').style.right = `${document.querySelector('.product__top')?.offsetLeft}px`;
      }
      setTimeout(function () {
        document.querySelector(".js-variant-popup-btn").setAttribute("type", "submit");
      }, 1000);
    });
  }

  closeButtons.forEach(closeButton => {
    closeButton.addEventListener("click", function () {
      customModelMain.classList.remove("variant-model-open");
      if (document.querySelector('.js-variant-popup-btn[type="submit"]'))
        document.querySelector(".js-variant-popup-btn").setAttribute("type", "button");
    });
  });

  if (bgOverlay) {
    bgOverlay.addEventListener("click", function () {
      customModelMain.classList.remove("variant-model-open");
      if (document.querySelector('.js-variant-popup-btn[type="submit"]')) {
        document.querySelector(".js-variant-popup-btn").setAttribute("type", "button");
      }
    });
  }

  if (stepOneBtn) {
    stepOneBtn.addEventListener("click", function () {
      window.rechargeWidget(false);
      paymentIcons.classList.remove("hide");
      variantBackBtn.classList.remove("hide");
      tabs.classList.add("variant-tabing");
      document.querySelector(".popup-title_2").classList.remove("hide");
      document.querySelector(".popup-title_1").classList.add("hide");
      if (shippingPlusSummary && shippingPlusSummary.length > 0) {
        shippingPlusSummary.forEach(element => {
          element.classList.add("hide");
        });
      }
      variantMetaQtyBtn.classList.add("hidden");
      stepOneBtn?.classList.add("hidden");
      stepTwoBtn?.classList.remove("hidden");
      checkboxRecahrge.checked = false;
      document.querySelector(".js-back-btn").classList.remove("hidden");
      document.querySelector(".js-variant-popup-btn").setAttribute("type", "submit");
    });
  }

  const closeModal = () => {
    const wrapper = stepTwoBtn.closest('.variant-custom-model-wrap');
    if (wrapper) wrapper.classList.remove('product-added');
    document.querySelector(".variant-change-tab").classList.remove("variant-tabing");
    document.querySelector(".popup-title_1").classList.remove("hide");
    if (shippingPlusSummary && shippingPlusSummary.length > 0) {
      shippingPlusSummary.forEach(element => {
        element.classList.remove("hide");
      });
    }
    document.querySelector(".popup-title_2").classList.add("hide");
    document.querySelector(".popup-title_3").classList.add("hide");
    document.querySelector(".js-back-btn").classList.add("hidden");
    //if there is subscription, don´t add the second step
    if (stepTwoBtn.classList.contains('no-widget-screen-allow') === false) {
      document.querySelector(".js-variant-duplicate-btn").classList.add("hidden");
      document.querySelector(".js-variant-qty-meta").classList.remove("hidden");
    }
    document.querySelector(".custom-payment-icons_variant").classList.add("hide");
    checkboxRecahrge.checked = false;
    document.querySelector(".variant-custom-model-main").classList.remove("variant-model-open");

    document.querySelector(".continue_with").classList.remove("hidden");
    setTimeout(function () {
      document.querySelector(".js-variant-popup-btn").setAttribute("type", "button");
      checkBtnForVariantsAndSetSubmit();
      document.querySelector(".js-variant-popup-btn span").innerHTML = document.querySelector(".js-variant-popup-btn").getAttribute("data-title");
    }, 1500);
    variantSelector.forEach((Element) => {
      Element.classList.remove("active");
    });
  }
  if (stepTwoBtn) {
    stepTwoBtn.addEventListener("click", function () {
      if (document.body.classList.contains('pdp-upsell-ab-test')) {
        if (stepTwoBtn.classList.contains('loading')) return;
        stepTwoBtn.classList.add('loading');
        document.body.classList.add('upsell-not-added-yet');
        document.querySelector('.js-variant-popup-btn[type="submit"]').click();
        document.querySelector('.js-variant-popup-btn[type="submit"]').classList.add("submitted");
        document.addEventListener('cart:item-added', () => {
          if (document.body.classList.contains('upsell-not-added-yet')) {
            stepTwoBtn.classList.remove('loading');
            document.body.classList.remove('upsell-not-added-yet');
            const wrapper = stepTwoBtn.closest('.variant-custom-model-wrap');
            if (wrapper) wrapper.classList.add('product-added');
            setTimeout(() => {
              closeModal();
              if (PDPUpsellModalApp.open() == false) {
                PDPUpsellModalApp.openCart();
              }
            }, 1600);
          }
        });
      } else {
        document.querySelector('.js-variant-popup-btn[type="submit"]').click();
        document.querySelector('.js-variant-popup-btn[type="submit"]').classList.add("submitted");
        closeModal();
      }
    });
  }

  if(variantBackBtn)
    variantBackBtn.addEventListener("click", function () {
    variantBackBtn.classList.add("hide");
    tabs.classList.remove("variant-tabing");
    paymentIcons.classList.add("hide");
    document.querySelector(".popup-title_2").classList.add("hide");
    document.querySelector(".popup-title_1").classList.remove("hide");
    if (shippingPlusSummary && shippingPlusSummary.length > 0) {
      shippingPlusSummary.forEach(element => {
        element.classList.remove("hide");
      });
    }
    variantMetaQtyBtn.innerHTML = ckContinueWithText;
    variantMetaQtyBtn.classList.remove("hidden");
    document.querySelector(".popup-title_3").classList.add("hide");
    stepOneBtn?.classList.remove("hidden");
    stepTwoBtn?.classList.add("hidden");
    document.querySelector(".js-back-btn").classList.add("hidden");
    variantSelector.forEach((Element) => {
      Element.classList.remove("active");
    });
  });

  //Variant Change Event
  variantSelector.forEach((Ele) => {
    Ele.addEventListener("click", function (evt) {
     
      variantSelector.forEach((Element) => {
        Element.classList.remove("active");
      });
      let variantTitle = evt.currentTarget.getAttribute("data-variant-title")
      let variantMetaQty = parseInt(evt.currentTarget.getAttribute("data-variant-qty"));
    
      if(typeof(hbFirstVariant) !== 'undefined') { 
        let compareAtPrice = evt.currentTarget.getAttribute("data-variant-compare-at-price")
        let orginalPrice = evt.currentTarget.getAttribute("data-variant-price") 
        const productId = parseInt(evt.currentTarget.getAttribute("data-product-id"));

        if(productId === hbFirstVariant.products[0][0] && orginalPrice) {
          if(compareAtPrice) {
            hbFirstVariant.discount = (((parseInt(compareAtPrice) - parseInt(orginalPrice)) / parseInt(compareAtPrice)) * 100).toFixed(2);
          } else {
            hbFirstVariant.discount = 0;
          }
          
        } else {
          hbFirstVariant.discount = parseFloat(evt.currentTarget.getAttribute("data-metafield-discount"));
        }

        document.querySelectorAll('[js-hb-discount-value-input]').forEach(input => {
          input.value = hbFirstVariant.discount;
        })

        if(document.querySelector('[data-bundle-product-discount-amount]')) {
          document.querySelector('[data-bundle-product-discount-amount]').setAttribute('data-bundle-product-discount-amount', hbFirstVariant.discount)
        }

        let bundleOneTimePriceWithoutDiscount = 0;
        let bundleOneTimePriceWithDiscount = 0;
        let bundleSubscriptionPriceWithoutDiscount = 0;
        let bundleSubscriptionPriceWithDiscount = 0;
        let bundleOriginalPrice = 0;

        hbFirstVariant.products.forEach(product => {
          if(productId === product[0]) {
            bundleOneTimePriceWithoutDiscount = bundleOneTimePriceWithoutDiscount + (variantMetaQty * product[2]);
            bundleSubscriptionPriceWithoutDiscount = bundleSubscriptionPriceWithoutDiscount + (variantMetaQty * product[3]);
            bundleOriginalPrice = bundleOriginalPrice + (variantMetaQty * product[2]);
          } else {
            bundleOneTimePriceWithoutDiscount = bundleOneTimePriceWithoutDiscount + (product[1] * product[2]);
            bundleSubscriptionPriceWithoutDiscount = bundleSubscriptionPriceWithoutDiscount + (product[1] * product[3]);
            bundleOriginalPrice = bundleOriginalPrice + (product[1] * product[2]);
          }
          
        })

        bundleOneTimePriceWithDiscount = ((100 - hbFirstVariant.discount) / 100) * bundleOneTimePriceWithoutDiscount
        bundleSubscriptionPriceWithDiscount = ((100 - hbFirstVariant.discount) / 100) * bundleSubscriptionPriceWithoutDiscount

        document.querySelectorAll('[js-bundle-product-price-subscription]').forEach(priceTag => {
          priceTag.innerHTML = formatMoney(bundleSubscriptionPriceWithDiscount).replace('.00', '');
        })

        document.querySelectorAll('[js-bundle-product-price-onetime]').forEach(priceTag => {
          priceTag.innerHTML = formatMoney(bundleOneTimePriceWithDiscount).replace('.00', '');
        })

        if(hbFirstVariant.discount === "0.00") {
          window.bundleSubscriptionPriceWithoutDiscountBundle = bundleOneTimePriceWithoutDiscount;
        } else {
          window.bundleSubscriptionPriceWithoutDiscountBundle = bundleSubscriptionPriceWithoutDiscount;
        }
        
        window.bundleSubscriptionPriceWithDiscountBundle = bundleSubscriptionPriceWithDiscount;
        window.bundleOriginalPriceBundle = bundleOriginalPrice;
        window.bundleCompareAtPrice = compareAtPrice;
        window.bundleOrginalPrice = orginalPrice;

        document.querySelectorAll('[js-bundle-original-price]').forEach(priceTag => {
          if (document.querySelector(".js-bundle-recharge-checkbox")?.checked) {
            priceTag.innerHTML = formatMoney(bundleSubscriptionPriceWithoutDiscount).replace('.00', '');
          } else {
            priceTag.innerHTML = formatMoney(bundleOriginalPrice).replace('.00', '');
          }

          if (parseInt(compareAtPrice) <= parseInt(orginalPrice)) {
            priceTag.style.display = 'none';
          } else {
            priceTag.style.display = 'inline-block';
          }

        })

        if(document.querySelector(".js-discount-price")){
          document.querySelector(".js-discount-price").innerHTML = formatMoney(window?.bundleSubscriptionPriceWithoutDiscountBundle - window?.bundleSubscriptionPriceWithDiscountBundle).replace('.00', '');
        }

      }

      // Update the quantity input field for the specific variant
      let quantityInput = document.querySelector('input[data-quantity-input-from-parent]');
      if (quantityInput) {
        quantityInput.value = variantMetaQty;
      }
      evt.currentTarget.classList.add("active");
      if(variantMetaQtyBtn){
        variantMetaQtyBtn.innerHTML = ckContinueWithText + ' ' + variantMetaQty + 'x';
      }
      if (mainSelect) {
        mainSelect.value = variantTitle;
        mainSelect.dispatchEvent(new Event("change"));
      }
    });
  });

  //Checkbox
  checkboxRecahrge?.addEventListener("change", function () {
    if (checkboxRecahrge.checked) {
      window.rechargeWidget(true);
      tabs.classList.add("recharge-enabled");
      document.querySelector(".popup-title_2").classList.add("hide");
      document.querySelector(".popup-title_3").classList.remove("hide");
    } else {
      window.rechargeWidget(false);
      tabs.classList.remove("recharge-enabled");
      document.querySelector(".popup-title_2").classList.remove("hide");
      document.querySelector(".popup-title_3").classList.add("hide");
    }
  });
}


var PDPUpsellModalApp = (() => {
  let modal = null;
  var open = () => {
    if (!modal) return false;
    modal.classList.add('open');
    return true;
  }
  var close = () => {
    if (!modal) return;
    modal.classList.remove('open');
    modal.querySelectorAll('.selected[js-upsell-product]').forEach(element => {
      element.classList.remove('selected');
    });
    modal.classList.remove('upsell-selected');
  }
  var selectProduct = (product) => {
    if (!product || !modal) return;
    if (product.classList.contains('selected')) {
      product.classList.remove('selected');
      if (modal.querySelectorAll('.selected[js-upsell-product]').length == 0) {
        modal.classList.remove('upsell-selected');
      }
    } else {
      product.classList.add('selected');
      modal.classList.add('upsell-selected');
    }
  }
  var openCart = () => {
    const cartIcon = document.querySelector('[data-js-cart-icon]');
    if (cartIcon) cartIcon.click();
  }
  var atc = () => {
    if (!modal) return;
    const selectedProducts = modal.querySelectorAll('.selected[js-upsell-product]');
    if (selectedProducts.length == 0) {
      modal.classList.add('nothing-selected');
      setTimeout(() => {
        modal.classList.remove('nothing-selected');
      }, 1600);
    } else {
      let items = [];
      const submitButton = modal.querySelector('[js-pdp-upsell-atc]');
      if (submitButton) submitButton.classList.add('loading');
      selectedProducts.forEach(element => {
        let item = {};
        item.id = element.getAttribute('data-variant-id');
        item.quantity = 1;
        item.discount_percent = element.getAttribute('data-discount-percent');
        items.push(item);
      });
      window.cart.addItemsToCart(items).then(() => {
        if (submitButton) submitButton.classList.remove('loading');
        close();
        openCart();
      });
    }
  }
  var initialize = () => {
    modal = document.querySelector('[js-pdp-upsell-modal]');
    if (!modal) return;
    if (window.innerWidth >= 959) {
      modal.querySelector('.modal-body').style.right = `${document.querySelector('.product__top')?.offsetLeft}px`;
    }
    modal.querySelectorAll('[js-close]').forEach(element => {
      element.addEventListener('click', () => {
        close();
      });
    });
    modal.querySelectorAll('[js-gtc]').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        close();
        openCart();
      });
    });
    modal.querySelectorAll('[js-pdp-upsell-atc]').forEach(element => {
      element.addEventListener('click', () => {
        atc();
      });
    });
    modal.querySelectorAll('[js-upsell-product]').forEach(element => {
      element.addEventListener('click', () => {
        selectProduct(element);
      });
    });
  }
  return {
    init: initialize,
    open: open,
    close: close,
    openCart: openCart
  }
})();


const scrollbuttton = document.querySelectorAll(".js-scroll");
const shopReview = document.querySelector("#looxReviews");

if (scrollbuttton && shopReview) {
  scrollbuttton.forEach((button) => {
    button.addEventListener("click", function () {
      window.scroll({
        top: shopReview.offsetTop - 150,  // Subtract 130 pixels from the element's offsetTop
        behavior: "smooth"
      });
    });
  });
}


initModal();


(() => {
  if(document.querySelector('.template--suffix-bundle')) {
    const bundleModalBtn = document.querySelector(".js-bundle-popup-btn");
    const customModelMain = document.querySelector(".variant-custom-model-main");
    const tab = document.querySelector(".variant-change-tab");
    const checkboxRecahrge = document.querySelector(".js-bundle-recharge-checkbox");
    const bundleCSBtns = document.querySelectorAll('[js-custom-bundle-input]'); 
    const customSelectField = document.querySelector('[js-custom-bundle-select]');
    const bundleSubscriptionSelectFields = document.querySelectorAll('[js-subscription-select-field]'); 
    const bundleSubmitBtn = document.querySelector('[js-bundle-submit-btn]');

    if(customSelectField) {
      bundleCSBtns.forEach(btn => {
        btn.addEventListener('change', (e) => {
          const value = e.target.value;

          if(value === 'subscription') {
            customSelectField.classList.remove('hidden');

            bundleSubscriptionSelectFields.forEach(select => {
              select.selectedIndex = 1;
            })

            document.querySelectorAll('[js-bundle-product-price-subscription]').forEach(price => {
              price.classList.remove('hidden');
            })
            document.querySelectorAll('[js-bundle-product-price-onetime]').forEach(price => {
              price.classList.add('hidden');
            })

          } else {
            customSelectField.classList.add('hidden');

            bundleSubscriptionSelectFields.forEach(select => {
              select.selectedIndex = 0;
            })

            document.querySelectorAll('[js-bundle-product-price-subscription]').forEach(price => {
              price.classList.add('hidden');
            })
            document.querySelectorAll('[js-bundle-product-price-onetime]').forEach(price => {
              price.classList.remove('hidden');
            })

          }
        })  
      })
    }
  
    bundleModalBtn.addEventListener("click", function (ele) {
      customModelMain.classList.add("variant-model-open");
      if (window.innerWidth >= 959) {
        customModelMain.querySelector('.variant-custom-model-inner').style.right = `${document.querySelector('.product__top')?.offsetLeft}px`;
      }
    });

    bundleSubmitBtn.addEventListener("click", function (ele) {
      customModelMain.classList.remove("variant-model-open");
    });
  
    checkboxRecahrge?.addEventListener("change", function () {
      if (checkboxRecahrge.checked) {
        tab.classList.add("recharge-enabled");
        document.querySelector(".popup-title_2").classList.add("hide");
        document.querySelector(".popup-title_3").classList.remove("hide");
        bundleCSBtns[1].click();
      } else {
        tab.classList.remove("recharge-enabled");
        document.querySelector(".popup-title_2").classList.remove("hide");
        document.querySelector(".popup-title_3").classList.add("hide");
        bundleCSBtns[0].click();
      }

      if(typeof(hbFirstVariant) !== 'undefined') { 
        document.querySelectorAll('[js-bundle-original-price]').forEach(priceTag => {
          if (document.querySelector(".js-bundle-recharge-checkbox")?.checked) {
            priceTag.innerHTML = formatMoney(window?.bundleSubscriptionPriceWithoutDiscountBundle).replace('.00', '');
          } else {
            priceTag.innerHTML = formatMoney(window?.bundleOriginalPriceBundle).replace('.00', '');
          }

          if (parseInt(window.bundleCompareAtPrice) <= parseInt(window.bundleOrginalPrice)) {
            priceTag.style.display = 'none';
          } else {
            priceTag.style.display = 'inline-block';
          }

        })

      }

      if(document.querySelector(".js-discount-price")){
        document.querySelector(".js-discount-price").innerHTML = formatMoney(window?.bundleSubscriptionPriceWithoutDiscountBundle - window?.bundleSubscriptionPriceWithDiscountBundle).replace('.00', '');
      }

    });

    customSelectField.addEventListener('change', (e) => {
      const value = e.target.value;
      bundleSubscriptionSelectFields.forEach(select => {
        select.selectedIndex = value; 
      })
    })

  }

  document.addEventListener("cart:updated", function (evt) {
    const cart = evt.detail.cart;
    let real_item_count = 0;
    let prio_id = null;
    for (let i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties?._prio_shipping) {
        prio_id = cart.items[i].variant_id;
      } else {
        real_item_count++;
      }
    }
    if (real_item_count == 0) {
      prioShippingApp.remove(document.querySelector(`[data-prio-product-variant-id="${prio_id}"]`));
    }
  });
})()




let imageActionBtns = document.querySelectorAll('.scroll-to-cart-btn');

if(imageActionBtns.length){
  imageActionBtns.forEach((btn)=>{
    btn.addEventListener('click',()=>{
      let addToCartBtn = document.querySelector('button[data-add-to-cart]');

      if(addToCartBtn){
        addToCartBtn.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      }
    })
  })
}